// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tournament Details Page Styles - PROSKINS Dark Theme */
.tournament-details {
  padding: var(--spacing-lg);
  max-width: 1200px;
  margin: 0 auto;
  background-color: var(--bg-primary);
  color: var(--text-primary);
}

.tournament-header {
  margin-bottom: var(--spacing-2xl);
}

.tournament-title-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: var(--spacing-lg);
}

.tournament-title {
  margin: 0;
  color: var(--text-primary);
  font-size: var(--font-size-4xl);
  font-weight: bold;
}

.tournament-description {
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.5;
  font-size: var(--font-size-lg);
}

.tournament-meta {
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  margin-top: var(--spacing-sm);
}

.header-actions {
  display: flex;
  align-items: center;
  gap: var(--spacing-lg);
}

.back-button {
  padding: var(--spacing-sm) var(--spacing-lg);
  border: 2px solid var(--proskins-green);
  background: transparent;
  color: var(--proskins-green);
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.back-button:hover {
  background: var(--proskins-green);
  color: #000;
}

.error-message {
  background-color: rgba(255, 170, 0, 0.1);
  border: 1px solid var(--warning);
  color: var(--warning);
  padding: var(--spacing-sm);
  border-radius: var(--radius-sm);
  margin-bottom: var(--spacing-lg);
}

/* Navigation Tabs */
.tournament-tabs {
  border-bottom: 2px solid var(--border-primary);
  margin-bottom: var(--spacing-2xl);
  display: flex;
  gap: 0;
}

.tournament-details-tab-button {
  padding: var(--spacing-md) var(--spacing-lg);
  border: none;
  background-color: transparent;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  color: var(--text-secondary);
  font-weight: normal;
  font-size: var(--font-size-base);
  transition: all 0.3s ease;
}

.tournament-details-tab-button:hover {
  color: var(--proskins-green);
}

.tournament-details-tab-button.active {
  border-bottom-color: var(--proskins-green);
  color: var(--proskins-green);
  font-weight: bold;
}

/* Tab Content */
.tab-content {
  min-height: 400px;
}

/* Rounds Accordion Styles */
.rounds-accordion {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.round-accordion-item {
  border: 1px solid #e0e6ed;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  background: white;
}

.round-accordion-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Round Header */
.round-header {
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 1px solid transparent;
}

.round-header:hover {
  background-color: #f8f9fa;
}

.round-header.expanded {
  background-color: #f0f8ff;
  border-bottom-color: #e0e6ed;
}

.round-header.completed {
  background-color: #f8fff8;
}

.round-header.completed.expanded {
  background-color: #f0fff0;
}

.round-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.round-header-left {
  flex: 1 1;
}

.round-title-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 6px;
}

.round-title {
  font-size: 1.2em;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.round-status-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8em;
  font-weight: 500;
  text-transform: uppercase;
}

.round-status-badge.completed {
  background-color: #d4edda;
  color: #155724;
}

.round-status-badge.in-progress {
  background-color: #fff3cd;
  color: #856404;
}

.round-details-summary {
  color: #666;
  font-size: 0.9em;
  line-height: 1.4;
}

.round-header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.round-stats-summary {
  text-align: right;
}

.score-count {
  font-weight: 600;
  color: #007bff;
  font-size: 0.9em;
}

.expand-indicator {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.expand-arrow {
  font-size: 0.8em;
  color: #666;
  transition: transform 0.3s ease;
}

.expand-arrow.rotated {
  transform: rotate(180deg);
}

/* Round Details Panel */
.round-details-panel {
  padding: 20px;
  background-color: #fdfdfd;
  border-top: 1px solid #e0e6ed;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    max-height: 0;
    padding: 0 20px;
  }
  to {
    opacity: 1;
    max-height: 1000px;
    padding: 20px;
  }
}

.round-info-section {
  margin-bottom: 24px;
}

.round-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-label {
  font-size: 0.85em;
  color: #666;
  font-weight: 500;
}

.info-value {
  font-size: 0.95em;
  color: #333;
  font-weight: 600;
}

/* Scores Section */
.scores-section {
  margin-top: 24px;
}

.scores-title {
  font-size: 1.1em;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #e0e6ed;
}

.loading-scores {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px;
  justify-content: center;
  color: #666;
}

/* Tournament Details loading spinner */
.tournament-details-loading-spinner-small {
  width: 16px;
  height: 16px;
  border: 2px solid #e0e6ed;
  border-left-color: #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.scores-table-container {
  overflow-x: auto;
}

.scores-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.scores-table th {
  background-color: #f8f9fa;
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: #333;
  font-size: 0.9em;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.scores-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #e9ecef;
}

.score-row:hover {
  background-color: #f8f9fa;
}

.player-name {
  font-weight: 600;
  color: #333;
}

.score-value {
  font-weight: 700;
  color: #007bff;
  font-size: 1.1em;
}

.holes-count {
  color: #666;
}

.player-status {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75em;
  font-weight: 500;
  text-transform: uppercase;
}

.player-status.completed {
  background-color: #d4edda;
  color: #155724;
}

.player-status.in-progress {
  background-color: #fff3cd;
  color: #856404;
}

.no-scores-message {
  text-align: center;
  padding: 40px 20px;
  color: #666;
  font-style: italic;
  background-color: #f8f9fa;
  border-radius: 6px;
}

/* Detailed Scorecard Styles */
.scorecard-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.scores-summary-table {
  margin-bottom: 16px;
}

.player-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.player-info small {
  color: #666;
  font-size: 0.8em;
}

.avg-score {
  font-weight: 600;
  color: #495057;
}

/* Detailed Scorecard */
.detailed-scorecard {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
}

.scorecard-title {
  font-size: 1.1em;
  font-weight: 600;
  color: #333;
  margin: 0 0 20px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #dee2e6;
}

.player-scorecard {
  background: white;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.player-scorecard:last-child {
  margin-bottom: 0;
}

.player-scorecard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e9ecef;
}

.player-scorecard-header h4 {
  margin: 0;
  color: #333;
  font-size: 1.2em;
}

.total-score {
  font-size: 1.1em;
  font-weight: 700;
  color: #007bff;
  background: #e7f3ff;
  padding: 6px 12px;
  border-radius: 20px;
}

.scorecard-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.nine-holes {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  overflow: hidden;
}

.nine-header {
  background: #343a40;
  color: white;
  padding: 8px 16px;
  font-weight: 600;
  font-size: 0.9em;
  text-align: center;
}

.front-nine .nine-header {
  background: #28a745;
}

.back-nine .nine-header {
  background: #dc3545;
}

.holes-grid {
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: 0;
}

.hole-score {
  border-right: 1px solid #dee2e6;
  padding: 12px 8px;
  text-align: center;
  background: white;
  transition: background-color 0.2s ease;
}

.hole-score:last-child {
  border-right: none;
}

.hole-score.skin-winner {
  background-color: #fff3cd;
  border-color: #ffeaa7;
}

.hole-score.eagle-winner {
  background-color: #d4edda;
  border-color: #c3e6cb;
  position: relative;
}

.hole-score.eagle-winner::before {
  content: '';
  position: absolute;
  top: 2px;
  right: 2px;
  width: 8px;
  height: 8px;
  background-color: #28a745;
  border-radius: 50%;
}

.hole-number {
  font-size: 0.8em;
  color: #666;
  margin-bottom: 4px;
  font-weight: 500;
}

.hole-score-value {
  font-size: 1.3em;
  font-weight: 700;
  color: #333;
  margin-bottom: 2px;
  position: relative;
}

.skin-indicator {
  color: #f39c12;
  font-size: 0.8em;
  margin-left: 2px;
}

.eagle-indicator {
  color: #28a745;
  font-size: 0.9em;
  margin-left: 2px;
}

.hole-par {
  font-size: 0.7em;
  color: #888;
  font-weight: 500;
}

.nine-total {
  background: #f8f9fa;
  padding: 10px 16px;
  font-weight: 600;
  color: #495057;
  border-top: 1px solid #dee2e6;
  text-align: center;
}

/* Responsive Design for Scorecard */
@media (max-width: 1024px) {
  .scorecard-grid {
    gap: 12px;
  }
  
  .holes-grid {
    grid-template-columns: repeat(5, 1fr);
  }
  
  .hole-score {
    padding: 8px 6px;
  }
  
  .hole-score-value {
    font-size: 1.1em;
  }
}

@media (max-width: 768px) {
  .detailed-scorecard {
    padding: 16px;
  }
  
  .player-scorecard {
    padding: 12px;
  }
  
  .player-scorecard-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .holes-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .hole-score {
    padding: 6px 4px;
  }
  
  .hole-score-value {
    font-size: 1em;
  }
  
  .nine-total {
    padding: 8px 12px;
  }
}

@media (max-width: 480px) {
  .scorecard-container {
    gap: 16px;
  }
  
  .detailed-scorecard {
    padding: 12px;
  }
  
  .holes-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1px;
  }
  
  .hole-score {
    padding: 8px 4px;
  }
}

/* Text utilities */
.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

/* Responsive design */
@media (max-width: 768px) {
  .round-header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .round-header-right {
    justify-content: space-between;
    width: 100%;
  }

  .round-info-grid {
    grid-template-columns: 1fr;
  }

  .scores-table {
    font-size: 0.85em;
  }

  .scores-table th,
  .scores-table td {
    padding: 8px 12px;
  }
}

/* Overview Tab */
.overview-grid {
  display: grid;
  gap: var(--spacing-lg);
}

.tournament-info-card {
  padding: var(--spacing-lg);
  background: var(--bg-card);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-primary);
}

.tournament-info-title {
  margin-bottom: var(--spacing-lg);
  color: var(--text-primary);
  font-size: var(--font-size-2xl);
  font-weight: 600;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--spacing-lg);
}

.info-item {
  padding: var(--spacing-md);
  background: var(--bg-tertiary);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-primary);
}

.info-label {
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: var(--spacing-xs);
}

.info-value {
  color: var(--text-primary);
  font-size: var(--font-size-lg);
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: var(--spacing-lg);
  text-align: center;
}

.stat-item {
  padding: var(--spacing-lg);
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-lg);
  transition: transform 0.2s ease;
  border: 1px solid var(--border-primary);
}

.stat-item:hover {
  transform: translateY(-2px);
}

.stat-number {
  font-size: var(--font-size-3xl);
  font-weight: bold;
  margin-bottom: var(--spacing-xs);
}

.stat-label {
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
}

.stat-primary { color: var(--info); }
.stat-success { color: var(--success); }
.stat-warning { color: var(--warning); }
.stat-danger { color: var(--error); }

/* Leaderboard Tab */
.leaderboard-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--bg-card);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-primary);
}

.leaderboard-table th {
  padding: var(--spacing-md);
  text-align: left;
  background-color: var(--bg-tertiary);
  border-bottom: 2px solid var(--border-primary);
  font-weight: 600;
  color: var(--text-primary);
}

.leaderboard-table td {
  padding: var(--spacing-md);
  border-bottom: 1px solid var(--border-primary);
}

.leaderboard-table tr:hover {
  background-color: var(--bg-tertiary);
}

.rank-cell {
  font-weight: bold;
  color: var(--info);
}

.earnings-cell {
  text-align: right;
}

/* Player Info Styles */
.player-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.player-name {
  font-weight: 600;
  color: var(--text-primary);
  font-size: var(--font-size-base);
}

.player-details {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--font-size-sm);
}

.tier-info {
  color: var(--text-secondary);
  font-weight: 500;
}

.world-ranking {
  color: var(--proskins-green);
  font-weight: 600;
  background: rgba(34, 197, 94, 0.1);
  padding: 2px 6px;
  border-radius: var(--radius-sm);
  border: 1px solid rgba(34, 197, 94, 0.3);
}

/* Players Tab */
.players-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: var(--spacing-md);
}

.player-card {
  padding: var(--spacing-md);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  background-color: var(--bg-tertiary);
  transition: all 0.3s ease;
}

.player-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.player-name {
  font-weight: bold;
  font-size: var(--font-size-lg);
  color: var(--text-primary);
  margin-bottom: var(--spacing-xs);
}

.player-details {
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  margin-bottom: var(--spacing-xs);
}

.player-status {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-left: var(--spacing-sm);
}

.status-active { background-color: var(--success); }
.status-inactive { background-color: var(--error); }

/* Rounds Tab */
.rounds-grid {
  display: grid;
  gap: var(--spacing-md);
}

.round-card {
  padding: var(--spacing-lg);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: all 0.3s ease;
  background: var(--bg-tertiary);
}

.round-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.round-card.completed {
  background-color: rgba(0, 255, 136, 0.1);
  border-color: var(--success);
}

.round-card.in-progress {
  background-color: rgba(255, 170, 0, 0.1);
  border-color: var(--warning);
}

.round-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-sm);
}

.round-title {
  margin: 0;
  color: var(--text-primary);
  font-size: var(--font-size-xl);
  font-weight: 600;
}

.round-status {
  margin-left: var(--spacing-sm);
  font-size: var(--font-size-xs);
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--radius-sm);
  font-weight: bold;
  color: white;
}

.status-completed { background-color: var(--success); }
.status-in-progress { background-color: var(--warning); }

.round-details {
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  margin-bottom: var(--spacing-xs);
}

.round-current-hole {
  color: var(--info);
  font-size: var(--font-size-sm);
  font-weight: bold;
  margin-top: var(--spacing-xs);
}

.round-stats {
  text-align: center;
}

.round-score-count {
  font-size: var(--font-size-2xl);
  font-weight: bold;
  color: var(--info);
}

.round-score-label {
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
}

/* Betting Tab */
.betting-grid {
  display: grid;
  gap: var(--spacing-lg);
}

.wallet-card {
  padding: var(--spacing-lg);
  background: var(--bg-card);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-primary);
}

.wallet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.wallet-title {
  margin: 0;
  color: var(--text-primary);
  font-size: var(--font-size-2xl);
  font-weight: 600;
}

.wallet-balance {
  font-size: var(--font-size-3xl);
  font-weight: bold;
  color: var(--success);
  margin: var(--spacing-sm) 0 0 0;
}

.add-funds-button {
  padding: var(--spacing-sm) var(--spacing-lg);
  background: var(--info);
  color: white;
  border: none;
  border-radius: var(--radius-sm);
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease;
}

.add-funds-button:hover {
  background: var(--proskins-green);
  color: #000;
}

.available-players-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: var(--spacing-md);
}

.player-betting-card {
  padding: var(--spacing-md);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  background-color: var(--bg-tertiary);
  transition: all 0.3s ease;
}

.player-betting-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.player-betting-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: var(--spacing-sm);
}

.player-betting-info {
  flex: 1 1;
}

.player-betting-name {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  margin-bottom: var(--spacing-xs);
}

.player-betting-title {
  margin: 0;
  color: var(--text-primary);
  font-size: var(--font-size-xl);
  font-weight: 600;
}

.tier-badge {
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-xs);
  font-weight: bold;
}

.tier-a { background-color: rgba(255, 170, 0, 0.2); color: var(--warning); }
.tier-b { background-color: rgba(136, 136, 136, 0.2); color: var(--text-secondary); }
.tier-c { background-color: rgba(255, 68, 68, 0.2); color: var(--error); }
.tier-d { background-color: rgba(0, 255, 136, 0.2); color: var(--success); }

.player-betting-details {
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  margin-bottom: var(--spacing-xs);
}

.player-betting-status {
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
}

.player-betting-price {
  text-align: right;
}

.price-amount {
  font-size: var(--font-size-2xl);
  font-weight: bold;
  color: var(--success);
  margin-bottom: var(--spacing-xs);
}

.purchase-button {
  padding: var(--spacing-xs) var(--spacing-md);
  border-radius: var(--radius-sm);
  border: none;
  font-size: var(--font-size-sm);
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
}

.purchase-button:enabled {
  background-color: var(--info);
  color: white;
}

.purchase-button:enabled:hover {
  background-color: var(--proskins-green);
  color: #000;
}

.purchase-button:disabled {
  background-color: var(--text-muted);
  color: white;
  cursor: not-allowed;
}

/* My Players Section */
.my-players-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: var(--spacing-md);
}

.my-player-card {
  padding: var(--spacing-md);
  border: 1px solid var(--success);
  border-radius: var(--radius-lg);
  background-color: rgba(0, 255, 136, 0.1);
  transition: all 0.3s ease;
}

.my-player-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.my-player-status {
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-xs);
  font-weight: bold;
  color: white;
}

.status-active { background-color: var(--success); }
.status-inactive { background-color: var(--text-muted); }

/* Round Details Modal */
.round-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.round-modal {
  background-color: var(--bg-card);
  padding: var(--spacing-2xl);
  border-radius: var(--radius-xl);
  max-width: 800px;
  max-height: 80vh;
  overflow: auto;
  border: 1px solid var(--border-primary);
  box-shadow: var(--shadow-lg);
}

.round-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-lg);
}

.round-modal-title {
  margin: 0;
  color: var(--text-primary);
  font-size: var(--font-size-2xl);
  font-weight: 600;
}

.round-modal-close {
  background: none;
  border: none;
  font-size: var(--font-size-2xl);
  cursor: pointer;
  color: var(--text-muted);
  transition: color 0.3s ease;
}

.round-modal-close:hover {
  color: var(--text-primary);
}

.round-modal-info {
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 6px;
}

.round-scores-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}

.round-scores-table th {
  padding: 10px;
  text-align: left;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  font-weight: 600;
  color: #333;
}

.round-scores-table td {
  padding: 10px;
  border-bottom: 1px solid #dee2e6;
}

.round-scores-table tr:hover {
  background-color: #f8f9fa;
}

.score-status {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.8em;
  font-weight: bold;
  color: white;
}

.score-completed { background-color: #28a745; }
.score-in-progress { background-color: #ffc107; }

/* Loading and Error States */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  color: var(--text-muted);
  font-size: var(--font-size-xl);
}

.not-found-container {
  padding: var(--spacing-2xl);
  text-align: center;
}

.not-found-title {
  color: var(--text-muted);
  font-size: var(--font-size-3xl);
  margin-bottom: var(--spacing-sm);
}

.not-found-message {
  color: var(--text-muted);
  font-size: var(--font-size-lg);
  margin-bottom: var(--spacing-lg);
}

/* Responsive Design */
@media (max-width: 768px) {
  .tournament-title-section {
    flex-direction: column;
    gap: 15px;
  }
  
  .back-button {
    margin-left: 0;
    align-self: flex-start;
  }
  
  .tournament-tabs {
    overflow-x: auto;
    white-space: nowrap;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .players-grid,
  .available-players-grid,
  .my-players-grid {
    grid-template-columns: 1fr;
  }
  
  .round-modal {
    margin: 20px;
    padding: 20px;
  }
}

/* Additional Styles for Inline Style Replacement */
.rounds-container {
  padding: 20px;
}

.rounds-title {
  margin-bottom: 20px;
  color: #333;
}

.rounds-empty {
  text-align: center;
  color: #666;
  padding: 40px;
}

.rounds-list {
  display: grid;
  gap: 15px;
}

.round-item {
  padding: 20px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.round-item.completed {
  background-color: #e8f5e8;
}

.round-item.in-progress {
  background-color: #fff3cd;
}

.round-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.round-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.round-info h4 {
  margin: 0;
  color: #333;
}

.round-status-badge {
  margin-left: 10px;
  font-size: 0.8em;
  padding: 2px 8px;
  border-radius: 12px;
  color: white;
}

.round-status-badge.completed {
  background-color: #28a745;
}

.round-status-badge.in-progress {
  background-color: #ffc107;
}

.round-details {
  color: #666;
  margin-top: 5px;
}

.round-dates {
  color: #666;
  font-size: 0.9em;
  margin-top: 5px;
}

.round-current-hole {
  color: #007bff;
  font-size: 0.9em;
  margin-top: 5px;
  font-weight: bold;
}

.round-stats {
  text-align: center;
}

.round-score-count {
  font-size: 1.5em;
  font-weight: bold;
  color: #007bff;
}

.round-score-label {
  color: #666;
  font-size: 0.9em;
}

/* Modal Styles */
.round-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.round-modal {
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  max-width: 800px;
  max-height: 80vh;
  overflow: auto;
}

.round-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.round-modal-title {
  margin: 0;
  color: #333;
  font-size: 1.5em;
  font-weight: 600;
}

.round-modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  transition: color 0.3s ease;
}

.round-modal-close:hover {
  color: #333;
}

.round-modal-info {
  margin-bottom: var(--spacing-lg);
  padding: var(--spacing-md);
  background: var(--bg-tertiary);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-primary);
}

.round-scores-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: var(--spacing-md);
}

.round-scores-table th {
  padding: var(--spacing-sm);
  text-align: left;
  background-color: var(--bg-tertiary);
  border-bottom: 1px solid var(--border-primary);
  font-weight: 600;
  color: var(--text-primary);
}

.round-scores-table td {
  padding: var(--spacing-sm);
  border-bottom: 1px solid var(--border-primary);
}

.round-scores-table tr:hover {
  background-color: var(--bg-tertiary);
}

.score-status {
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-xs);
  font-weight: bold;
  color: white;
}

.score-status.completed {
  background-color: var(--success);
}

.score-status.in-progress {
  background-color: var(--warning);
}

/* Player Status Indicator */
.player-status-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-left: 10px;
}

.player-status-indicator.active {
  background-color: #28a745;
}

.player-status-indicator.inactive {
  background-color: #dc3545;
}

/* Betting Tab Styles */
.betting-grid {
  display: grid;
  gap: 20px;
}

.wallet-card {
  padding: 20px;
}

.wallet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.wallet-title {
  margin: 0;
  color: #333;
}

.wallet-balance {
  font-size: 2em;
  font-weight: bold;
  color: #28a745;
  margin: 10px 0 0 0;
}

.available-players-card,
.my-players-card {
  padding: 20px;
}

.available-players-title,
.my-players-title {
  margin-bottom: 20px;
  color: #333;
}

.available-players-grid,
.my-players-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
}

.player-betting-card {
  padding: 15px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  background-color: #f8f9fa;
}

.player-betting-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.player-betting-info {
  flex: 1 1;
}

.player-betting-name {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.player-betting-title {
  margin: 0;
  color: #333;
}

.player-betting-details {
  color: #666;
  font-size: 0.9em;
  margin-bottom: 5px;
}

.player-betting-status {
  color: #666;
  font-size: 0.9em;
}

.player-betting-price {
  text-align: right;
}

.price-amount {
  font-size: 1.5em;
  font-weight: bold;
  color: #28a745;
  margin-bottom: 8px;
}

.my-player-card {
  padding: 15px;
  border: 1px solid #28a745;
  border-radius: 8px;
  background-color: #e8f5e8;
}

.my-player-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.my-player-info {
  flex: 1 1;
}

.my-player-name-section {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.my-player-name {
  margin: 0;
  color: #333;
}

.my-player-details {
  color: #666;
  font-size: 0.9em;
  margin-bottom: 5px;
}

.my-player-purchase {
  color: #28a745;
  font-size: 0.9em;
  font-weight: bold;
}

.text-right {
  text-align: right;
}

/* Not Found Styles */
.not-found-container {
  padding: 40px;
  text-align: center;
}

.not-found-title {
  color: #666;
  margin-bottom: 10px;
}

.not-found-message {
  color: #999;
  margin-bottom: 20px;
}

/* Loading Styles */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  color: #666;
}

.loading-content {
  text-align: center;
}

/* Tournament Details main loading spinner */
.tournament-details-loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.tournament-details-spinner {
  animation: spin 1s linear infinite;
  border-radius: 50%;
  height: 48px;
  width: 48px;
  border-bottom: 2px solid #2563eb;
  margin: 0 auto;
}

.loading-text {
  margin-top: 16px;
  color: #6b7280;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Additional Utility Classes */
.section-margin {
  margin-bottom: 20px;
}

.section-title {
  color: #555;
  margin-bottom: 10px;
}

.section-content {
  padding-left: 20px;
}

.section-item {
  margin-bottom: 5px;
}

.overflow-auto {
  overflow-x: auto;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-bold {
  font-weight: bold;
}

.flex-1 {
  flex: 1 1;
}

.flex-center {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
}

/* Status Badge */
.status-badge {
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.9em;
  font-weight: bold;
}

/* Live Simulation Status */
.live-status {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #00ff88, #00cc6a);
  color: #000;
  padding: 8px 16px;
  border-radius: 25px;
  font-weight: bold;
  font-size: 0.9em;
  margin-left: 15px;
  animation: pulse 2s infinite;
}

.live-indicator {
  width: 8px;
  height: 8px;
  background: #ff4444;
  border-radius: 50%;
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0; }
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

.live-text {
  font-size: 0.9em;
}

/* Notification System */
.notification-container {
  position: relative;
}

.notification-bell {
  background: #2a2a2a;
  border: 2px solid #00ff88;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.2em;
  transition: all 0.3s ease;
  position: relative;
}

.notification-bell:hover {
  background: #00ff88;
  transform: scale(1.1);
}

.notification-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #ff4444;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7em;
  font-weight: bold;
}

.notification-dropdown {
  position: absolute;
  top: 50px;
  right: 0;
  width: 350px;
  background: #1e1e1e;
  border: 1px solid #333333;
  border-radius: 1rem;
  box-shadow: 0 8px 32px rgba(0, 255, 136, 0.2);
  z-index: 1000;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.notification-header {
  padding: 1rem;
  border-bottom: 1px solid #333333;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.notification-header h4 {
  margin: 0;
  color: #ffffff;
  font-size: 1.1em;
}

.skins-count {
  color: #00ff88;
  font-size: 0.9em;
  font-weight: bold;
}

.notification-list {
  max-height: 300px;
  overflow-y: auto;
}

.no-notifications {
  padding: 2rem;
  text-align: center;
  color: #888888;
}

.notification-item {
  padding: 1rem;
  border-bottom: 1px solid #333333;
  transition: background 0.2s ease;
  cursor: pointer;
}

.notification-item:hover {
  background: #2a2a2a;
}

.notification-item.my-player {
  background: rgba(0, 255, 136, 0.1);
  border-left: 4px solid #00ff88;
}

.notification-content {
  color: #ffffff;
  font-size: 0.95em;
  line-height: 1.4;
  margin-bottom: 0.5rem;
}

.my-player-tag {
  background: #00ff88;
  color: #000;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.7em;
  font-weight: bold;
  margin-left: 8px;
}

.notification-time {
  color: #888888;
  font-size: 0.8em;
}

.notification-footer {
  padding: 1rem;
  border-top: 1px solid #333333;
  text-align: center;
}

.clear-notifications {
  background: transparent;
  color: #00ff88;
  border: 1px solid #00ff88;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9em;
  transition: all 0.3s ease;
}

.clear-notifications:hover {
  background: #00ff88;
  color: #000;
}

/* Responsive Design for Mobile */
@media (max-width: 768px) {
  .header-actions {
    gap: 10px;
  }
  
  .notification-dropdown {
    width: 300px;
    right: -50px;
  }
  
  .live-status {
    margin-left: 8px;
    padding: 6px 12px;
    font-size: 0.8em;
  }
  
  .notification-bell {
    width: 40px;
    height: 40px;
    font-size: 1.1em;
  }
}

@media (max-width: 480px) {
  .tournament-title-section {
    flex-direction: column;
    gap: 15px;
  }
  
  .header-actions {
    justify-content: flex-end;
  }
  
  .notification-dropdown {
    width: 280px;
    right: -100px;
  }
  
  .live-status {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TournamentDetails.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;EACd,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,uCAAuC;EACvC,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,qBAAqB;EACrB,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,8CAA8C;EAC9C,iCAAiC;EACjC,aAAa;EACb,MAAM;AACR;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,oCAAoC;EACpC,4BAA4B;EAC5B,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,eAAe;EACjB;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,MAAM;AACR;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE;IACE,SAAS;EACX;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,+BAA+B;EAC/B,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,gBAAgB,kBAAkB,EAAE;AACpC,gBAAgB,qBAAqB,EAAE;AACvC,gBAAgB,qBAAqB,EAAE;AACvC,eAAe,mBAAmB,EAAE;;AAEpC,oBAAoB;AACpB;EACE,WAAW;EACX,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,oCAAoC;EACpC,8CAA8C;EAC9C,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,4DAA4D;EAC5D,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA,iBAAiB,gCAAgC,EAAE;AACnD,mBAAmB,8BAA8B,EAAE;;AAEnD,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,4CAA4C;EAC5C,+BAA+B;EAC/B,iBAAiB;EACjB,YAAY;AACd;;AAEA,oBAAoB,gCAAgC,EAAE;AACtD,sBAAsB,gCAAgC,EAAE;;AAExD;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,UAAU,wCAAwC,EAAE,qBAAqB,EAAE;AAC3E,UAAU,0CAA0C,EAAE,4BAA4B,EAAE;AACpF,UAAU,wCAAwC,EAAE,mBAAmB,EAAE;AACzE,UAAU,wCAAwC,EAAE,qBAAqB,EAAE;;AAE3E;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,YAAY;EACZ,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,4DAA4D;EAC5D,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;AACd;;AAEA,iBAAiB,gCAAgC,EAAE;AACnD,mBAAmB,mCAAmC,EAAE;;AAExD,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA,mBAAmB,yBAAyB,EAAE;AAC9C,qBAAqB,yBAAyB,EAAE;;AAEhD,6BAA6B;AAC7B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,mDAAmD;AACnD;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,8BAA8B;EAC9B,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,oCAAoC;EACpC,8CAA8C;EAC9C,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qDAAqD;EACrD,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,UAAU,UAAU,EAAE;EACtB,YAAY,UAAU,EAAE;AAC1B;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,sBAAsB,EAAE;EAC9B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Tournament Details Page Styles - PROSKINS Dark Theme */\n.tournament-details {\n  padding: var(--spacing-lg);\n  max-width: 1200px;\n  margin: 0 auto;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n.tournament-header {\n  margin-bottom: var(--spacing-2xl);\n}\n\n.tournament-title-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: var(--spacing-lg);\n}\n\n.tournament-title {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: var(--font-size-4xl);\n  font-weight: bold;\n}\n\n.tournament-description {\n  color: var(--text-secondary);\n  margin: 0;\n  line-height: 1.5;\n  font-size: var(--font-size-lg);\n}\n\n.tournament-meta {\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n  margin-top: var(--spacing-sm);\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-lg);\n}\n\n.back-button {\n  padding: var(--spacing-sm) var(--spacing-lg);\n  border: 2px solid var(--proskins-green);\n  background: transparent;\n  color: var(--proskins-green);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.back-button:hover {\n  background: var(--proskins-green);\n  color: #000;\n}\n\n.error-message {\n  background-color: rgba(255, 170, 0, 0.1);\n  border: 1px solid var(--warning);\n  color: var(--warning);\n  padding: var(--spacing-sm);\n  border-radius: var(--radius-sm);\n  margin-bottom: var(--spacing-lg);\n}\n\n/* Navigation Tabs */\n.tournament-tabs {\n  border-bottom: 2px solid var(--border-primary);\n  margin-bottom: var(--spacing-2xl);\n  display: flex;\n  gap: 0;\n}\n\n.tournament-details-tab-button {\n  padding: var(--spacing-md) var(--spacing-lg);\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  color: var(--text-secondary);\n  font-weight: normal;\n  font-size: var(--font-size-base);\n  transition: all 0.3s ease;\n}\n\n.tournament-details-tab-button:hover {\n  color: var(--proskins-green);\n}\n\n.tournament-details-tab-button.active {\n  border-bottom-color: var(--proskins-green);\n  color: var(--proskins-green);\n  font-weight: bold;\n}\n\n/* Tab Content */\n.tab-content {\n  min-height: 400px;\n}\n\n/* Rounds Accordion Styles */\n.rounds-accordion {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.round-accordion-item {\n  border: 1px solid #e0e6ed;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  background: white;\n}\n\n.round-accordion-item:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Round Header */\n.round-header {\n  padding: 16px 20px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-bottom: 1px solid transparent;\n}\n\n.round-header:hover {\n  background-color: #f8f9fa;\n}\n\n.round-header.expanded {\n  background-color: #f0f8ff;\n  border-bottom-color: #e0e6ed;\n}\n\n.round-header.completed {\n  background-color: #f8fff8;\n}\n\n.round-header.completed.expanded {\n  background-color: #f0fff0;\n}\n\n.round-header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.round-header-left {\n  flex: 1;\n}\n\n.round-title-section {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 6px;\n}\n\n.round-title {\n  font-size: 1.2em;\n  font-weight: 600;\n  color: #333;\n  margin: 0;\n}\n\n.round-status-badge {\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.8em;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.round-status-badge.completed {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.round-status-badge.in-progress {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.round-details-summary {\n  color: #666;\n  font-size: 0.9em;\n  line-height: 1.4;\n}\n\n.round-header-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.round-stats-summary {\n  text-align: right;\n}\n\n.score-count {\n  font-weight: 600;\n  color: #007bff;\n  font-size: 0.9em;\n}\n\n.expand-indicator {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.expand-arrow {\n  font-size: 0.8em;\n  color: #666;\n  transition: transform 0.3s ease;\n}\n\n.expand-arrow.rotated {\n  transform: rotate(180deg);\n}\n\n/* Round Details Panel */\n.round-details-panel {\n  padding: 20px;\n  background-color: #fdfdfd;\n  border-top: 1px solid #e0e6ed;\n  animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    max-height: 0;\n    padding: 0 20px;\n  }\n  to {\n    opacity: 1;\n    max-height: 1000px;\n    padding: 20px;\n  }\n}\n\n.round-info-section {\n  margin-bottom: 24px;\n}\n\n.round-info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.info-label {\n  font-size: 0.85em;\n  color: #666;\n  font-weight: 500;\n}\n\n.info-value {\n  font-size: 0.95em;\n  color: #333;\n  font-weight: 600;\n}\n\n/* Scores Section */\n.scores-section {\n  margin-top: 24px;\n}\n\n.scores-title {\n  font-size: 1.1em;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 16px 0;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #e0e6ed;\n}\n\n.loading-scores {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 20px;\n  justify-content: center;\n  color: #666;\n}\n\n/* Tournament Details loading spinner */\n.tournament-details-loading-spinner-small {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #e0e6ed;\n  border-left-color: #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.scores-table-container {\n  overflow-x: auto;\n}\n\n.scores-table {\n  width: 100%;\n  border-collapse: collapse;\n  border-radius: 6px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.scores-table th {\n  background-color: #f8f9fa;\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  font-size: 0.9em;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.scores-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.score-row:hover {\n  background-color: #f8f9fa;\n}\n\n.player-name {\n  font-weight: 600;\n  color: #333;\n}\n\n.score-value {\n  font-weight: 700;\n  color: #007bff;\n  font-size: 1.1em;\n}\n\n.holes-count {\n  color: #666;\n}\n\n.player-status {\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 0.75em;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.player-status.completed {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.player-status.in-progress {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.no-scores-message {\n  text-align: center;\n  padding: 40px 20px;\n  color: #666;\n  font-style: italic;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n}\n\n/* Detailed Scorecard Styles */\n.scorecard-container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.scores-summary-table {\n  margin-bottom: 16px;\n}\n\n.player-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.player-info small {\n  color: #666;\n  font-size: 0.8em;\n}\n\n.avg-score {\n  font-weight: 600;\n  color: #495057;\n}\n\n/* Detailed Scorecard */\n.detailed-scorecard {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.scorecard-title {\n  font-size: 1.1em;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 20px 0;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.player-scorecard {\n  background: white;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.player-scorecard:last-child {\n  margin-bottom: 0;\n}\n\n.player-scorecard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.player-scorecard-header h4 {\n  margin: 0;\n  color: #333;\n  font-size: 1.2em;\n}\n\n.total-score {\n  font-size: 1.1em;\n  font-weight: 700;\n  color: #007bff;\n  background: #e7f3ff;\n  padding: 6px 12px;\n  border-radius: 20px;\n}\n\n.scorecard-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.nine-holes {\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.nine-header {\n  background: #343a40;\n  color: white;\n  padding: 8px 16px;\n  font-weight: 600;\n  font-size: 0.9em;\n  text-align: center;\n}\n\n.front-nine .nine-header {\n  background: #28a745;\n}\n\n.back-nine .nine-header {\n  background: #dc3545;\n}\n\n.holes-grid {\n  display: grid;\n  grid-template-columns: repeat(9, 1fr);\n  gap: 0;\n}\n\n.hole-score {\n  border-right: 1px solid #dee2e6;\n  padding: 12px 8px;\n  text-align: center;\n  background: white;\n  transition: background-color 0.2s ease;\n}\n\n.hole-score:last-child {\n  border-right: none;\n}\n\n.hole-score.skin-winner {\n  background-color: #fff3cd;\n  border-color: #ffeaa7;\n}\n\n.hole-score.eagle-winner {\n  background-color: #d4edda;\n  border-color: #c3e6cb;\n  position: relative;\n}\n\n.hole-score.eagle-winner::before {\n  content: '';\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  width: 8px;\n  height: 8px;\n  background-color: #28a745;\n  border-radius: 50%;\n}\n\n.hole-number {\n  font-size: 0.8em;\n  color: #666;\n  margin-bottom: 4px;\n  font-weight: 500;\n}\n\n.hole-score-value {\n  font-size: 1.3em;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 2px;\n  position: relative;\n}\n\n.skin-indicator {\n  color: #f39c12;\n  font-size: 0.8em;\n  margin-left: 2px;\n}\n\n.eagle-indicator {\n  color: #28a745;\n  font-size: 0.9em;\n  margin-left: 2px;\n}\n\n.hole-par {\n  font-size: 0.7em;\n  color: #888;\n  font-weight: 500;\n}\n\n.nine-total {\n  background: #f8f9fa;\n  padding: 10px 16px;\n  font-weight: 600;\n  color: #495057;\n  border-top: 1px solid #dee2e6;\n  text-align: center;\n}\n\n/* Responsive Design for Scorecard */\n@media (max-width: 1024px) {\n  .scorecard-grid {\n    gap: 12px;\n  }\n  \n  .holes-grid {\n    grid-template-columns: repeat(5, 1fr);\n  }\n  \n  .hole-score {\n    padding: 8px 6px;\n  }\n  \n  .hole-score-value {\n    font-size: 1.1em;\n  }\n}\n\n@media (max-width: 768px) {\n  .detailed-scorecard {\n    padding: 16px;\n  }\n  \n  .player-scorecard {\n    padding: 12px;\n  }\n  \n  .player-scorecard-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .holes-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  \n  .hole-score {\n    padding: 6px 4px;\n  }\n  \n  .hole-score-value {\n    font-size: 1em;\n  }\n  \n  .nine-total {\n    padding: 8px 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .scorecard-container {\n    gap: 16px;\n  }\n  \n  .detailed-scorecard {\n    padding: 12px;\n  }\n  \n  .holes-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1px;\n  }\n  \n  .hole-score {\n    padding: 8px 4px;\n  }\n}\n\n/* Text utilities */\n.text-center {\n  text-align: center;\n}\n\n.text-right {\n  text-align: right;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .round-header-content {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .round-header-right {\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  .round-info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .scores-table {\n    font-size: 0.85em;\n  }\n\n  .scores-table th,\n  .scores-table td {\n    padding: 8px 12px;\n  }\n}\n\n/* Overview Tab */\n.overview-grid {\n  display: grid;\n  gap: var(--spacing-lg);\n}\n\n.tournament-info-card {\n  padding: var(--spacing-lg);\n  background: var(--bg-card);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-primary);\n}\n\n.tournament-info-title {\n  margin-bottom: var(--spacing-lg);\n  color: var(--text-primary);\n  font-size: var(--font-size-2xl);\n  font-weight: 600;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: var(--spacing-lg);\n}\n\n.info-item {\n  padding: var(--spacing-md);\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-primary);\n}\n\n.info-label {\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin-bottom: var(--spacing-xs);\n}\n\n.info-value {\n  color: var(--text-primary);\n  font-size: var(--font-size-lg);\n}\n\n/* Stats Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: var(--spacing-lg);\n  text-align: center;\n}\n\n.stat-item {\n  padding: var(--spacing-lg);\n  background-color: var(--bg-tertiary);\n  border-radius: var(--radius-lg);\n  transition: transform 0.2s ease;\n  border: 1px solid var(--border-primary);\n}\n\n.stat-item:hover {\n  transform: translateY(-2px);\n}\n\n.stat-number {\n  font-size: var(--font-size-3xl);\n  font-weight: bold;\n  margin-bottom: var(--spacing-xs);\n}\n\n.stat-label {\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n}\n\n.stat-primary { color: var(--info); }\n.stat-success { color: var(--success); }\n.stat-warning { color: var(--warning); }\n.stat-danger { color: var(--error); }\n\n/* Leaderboard Tab */\n.leaderboard-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: var(--bg-card);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-primary);\n}\n\n.leaderboard-table th {\n  padding: var(--spacing-md);\n  text-align: left;\n  background-color: var(--bg-tertiary);\n  border-bottom: 2px solid var(--border-primary);\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.leaderboard-table td {\n  padding: var(--spacing-md);\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.leaderboard-table tr:hover {\n  background-color: var(--bg-tertiary);\n}\n\n.rank-cell {\n  font-weight: bold;\n  color: var(--info);\n}\n\n.earnings-cell {\n  text-align: right;\n}\n\n/* Player Info Styles */\n.player-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.player-name {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: var(--font-size-base);\n}\n\n.player-details {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--font-size-sm);\n}\n\n.tier-info {\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.world-ranking {\n  color: var(--proskins-green);\n  font-weight: 600;\n  background: rgba(34, 197, 94, 0.1);\n  padding: 2px 6px;\n  border-radius: var(--radius-sm);\n  border: 1px solid rgba(34, 197, 94, 0.3);\n}\n\n/* Players Tab */\n.players-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: var(--spacing-md);\n}\n\n.player-card {\n  padding: var(--spacing-md);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  background-color: var(--bg-tertiary);\n  transition: all 0.3s ease;\n}\n\n.player-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.player-name {\n  font-weight: bold;\n  font-size: var(--font-size-lg);\n  color: var(--text-primary);\n  margin-bottom: var(--spacing-xs);\n}\n\n.player-details {\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n  margin-bottom: var(--spacing-xs);\n}\n\n.player-status {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-left: var(--spacing-sm);\n}\n\n.status-active { background-color: var(--success); }\n.status-inactive { background-color: var(--error); }\n\n/* Rounds Tab */\n.rounds-grid {\n  display: grid;\n  gap: var(--spacing-md);\n}\n\n.round-card {\n  padding: var(--spacing-lg);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: var(--bg-tertiary);\n}\n\n.round-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.round-card.completed {\n  background-color: rgba(0, 255, 136, 0.1);\n  border-color: var(--success);\n}\n\n.round-card.in-progress {\n  background-color: rgba(255, 170, 0, 0.1);\n  border-color: var(--warning);\n}\n\n.round-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--spacing-sm);\n}\n\n.round-title {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: var(--font-size-xl);\n  font-weight: 600;\n}\n\n.round-status {\n  margin-left: var(--spacing-sm);\n  font-size: var(--font-size-xs);\n  padding: var(--spacing-xs) var(--spacing-sm);\n  border-radius: var(--radius-sm);\n  font-weight: bold;\n  color: white;\n}\n\n.status-completed { background-color: var(--success); }\n.status-in-progress { background-color: var(--warning); }\n\n.round-details {\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n  margin-bottom: var(--spacing-xs);\n}\n\n.round-current-hole {\n  color: var(--info);\n  font-size: var(--font-size-sm);\n  font-weight: bold;\n  margin-top: var(--spacing-xs);\n}\n\n.round-stats {\n  text-align: center;\n}\n\n.round-score-count {\n  font-size: var(--font-size-2xl);\n  font-weight: bold;\n  color: var(--info);\n}\n\n.round-score-label {\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n}\n\n/* Betting Tab */\n.betting-grid {\n  display: grid;\n  gap: var(--spacing-lg);\n}\n\n.wallet-card {\n  padding: var(--spacing-lg);\n  background: var(--bg-card);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-primary);\n}\n\n.wallet-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.wallet-title {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: var(--font-size-2xl);\n  font-weight: 600;\n}\n\n.wallet-balance {\n  font-size: var(--font-size-3xl);\n  font-weight: bold;\n  color: var(--success);\n  margin: var(--spacing-sm) 0 0 0;\n}\n\n.add-funds-button {\n  padding: var(--spacing-sm) var(--spacing-lg);\n  background: var(--info);\n  color: white;\n  border: none;\n  border-radius: var(--radius-sm);\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.add-funds-button:hover {\n  background: var(--proskins-green);\n  color: #000;\n}\n\n.available-players-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: var(--spacing-md);\n}\n\n.player-betting-card {\n  padding: var(--spacing-md);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  background-color: var(--bg-tertiary);\n  transition: all 0.3s ease;\n}\n\n.player-betting-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.player-betting-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: var(--spacing-sm);\n}\n\n.player-betting-info {\n  flex: 1;\n}\n\n.player-betting-name {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  margin-bottom: var(--spacing-xs);\n}\n\n.player-betting-title {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: var(--font-size-xl);\n  font-weight: 600;\n}\n\n.tier-badge {\n  padding: var(--spacing-xs) var(--spacing-sm);\n  border-radius: var(--radius-sm);\n  font-size: var(--font-size-xs);\n  font-weight: bold;\n}\n\n.tier-a { background-color: rgba(255, 170, 0, 0.2); color: var(--warning); }\n.tier-b { background-color: rgba(136, 136, 136, 0.2); color: var(--text-secondary); }\n.tier-c { background-color: rgba(255, 68, 68, 0.2); color: var(--error); }\n.tier-d { background-color: rgba(0, 255, 136, 0.2); color: var(--success); }\n\n.player-betting-details {\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n  margin-bottom: var(--spacing-xs);\n}\n\n.player-betting-status {\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n}\n\n.player-betting-price {\n  text-align: right;\n}\n\n.price-amount {\n  font-size: var(--font-size-2xl);\n  font-weight: bold;\n  color: var(--success);\n  margin-bottom: var(--spacing-xs);\n}\n\n.purchase-button {\n  padding: var(--spacing-xs) var(--spacing-md);\n  border-radius: var(--radius-sm);\n  border: none;\n  font-size: var(--font-size-sm);\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.purchase-button:enabled {\n  background-color: var(--info);\n  color: white;\n}\n\n.purchase-button:enabled:hover {\n  background-color: var(--proskins-green);\n  color: #000;\n}\n\n.purchase-button:disabled {\n  background-color: var(--text-muted);\n  color: white;\n  cursor: not-allowed;\n}\n\n/* My Players Section */\n.my-players-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: var(--spacing-md);\n}\n\n.my-player-card {\n  padding: var(--spacing-md);\n  border: 1px solid var(--success);\n  border-radius: var(--radius-lg);\n  background-color: rgba(0, 255, 136, 0.1);\n  transition: all 0.3s ease;\n}\n\n.my-player-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.my-player-status {\n  padding: var(--spacing-xs) var(--spacing-sm);\n  border-radius: var(--radius-sm);\n  font-size: var(--font-size-xs);\n  font-weight: bold;\n  color: white;\n}\n\n.status-active { background-color: var(--success); }\n.status-inactive { background-color: var(--text-muted); }\n\n/* Round Details Modal */\n.round-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0,0,0,0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.round-modal {\n  background-color: var(--bg-card);\n  padding: var(--spacing-2xl);\n  border-radius: var(--radius-xl);\n  max-width: 800px;\n  max-height: 80vh;\n  overflow: auto;\n  border: 1px solid var(--border-primary);\n  box-shadow: var(--shadow-lg);\n}\n\n.round-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--spacing-lg);\n}\n\n.round-modal-title {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: var(--font-size-2xl);\n  font-weight: 600;\n}\n\n.round-modal-close {\n  background: none;\n  border: none;\n  font-size: var(--font-size-2xl);\n  cursor: pointer;\n  color: var(--text-muted);\n  transition: color 0.3s ease;\n}\n\n.round-modal-close:hover {\n  color: var(--text-primary);\n}\n\n.round-modal-info {\n  margin-bottom: 20px;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 6px;\n}\n\n.round-scores-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 15px;\n}\n\n.round-scores-table th {\n  padding: 10px;\n  text-align: left;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n  font-weight: 600;\n  color: #333;\n}\n\n.round-scores-table td {\n  padding: 10px;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.round-scores-table tr:hover {\n  background-color: #f8f9fa;\n}\n\n.score-status {\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 0.8em;\n  font-weight: bold;\n  color: white;\n}\n\n.score-completed { background-color: #28a745; }\n.score-in-progress { background-color: #ffc107; }\n\n/* Loading and Error States */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 400px;\n  color: var(--text-muted);\n  font-size: var(--font-size-xl);\n}\n\n.not-found-container {\n  padding: var(--spacing-2xl);\n  text-align: center;\n}\n\n.not-found-title {\n  color: var(--text-muted);\n  font-size: var(--font-size-3xl);\n  margin-bottom: var(--spacing-sm);\n}\n\n.not-found-message {\n  color: var(--text-muted);\n  font-size: var(--font-size-lg);\n  margin-bottom: var(--spacing-lg);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .tournament-title-section {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .back-button {\n    margin-left: 0;\n    align-self: flex-start;\n  }\n  \n  .tournament-tabs {\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n  \n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .players-grid,\n  .available-players-grid,\n  .my-players-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .round-modal {\n    margin: 20px;\n    padding: 20px;\n  }\n}\n\n/* Additional Styles for Inline Style Replacement */\n.rounds-container {\n  padding: 20px;\n}\n\n.rounds-title {\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.rounds-empty {\n  text-align: center;\n  color: #666;\n  padding: 40px;\n}\n\n.rounds-list {\n  display: grid;\n  gap: 15px;\n}\n\n.round-item {\n  padding: 20px;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.round-item.completed {\n  background-color: #e8f5e8;\n}\n\n.round-item.in-progress {\n  background-color: #fff3cd;\n}\n\n.round-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n}\n\n.round-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.round-info h4 {\n  margin: 0;\n  color: #333;\n}\n\n.round-status-badge {\n  margin-left: 10px;\n  font-size: 0.8em;\n  padding: 2px 8px;\n  border-radius: 12px;\n  color: white;\n}\n\n.round-status-badge.completed {\n  background-color: #28a745;\n}\n\n.round-status-badge.in-progress {\n  background-color: #ffc107;\n}\n\n.round-details {\n  color: #666;\n  margin-top: 5px;\n}\n\n.round-dates {\n  color: #666;\n  font-size: 0.9em;\n  margin-top: 5px;\n}\n\n.round-current-hole {\n  color: #007bff;\n  font-size: 0.9em;\n  margin-top: 5px;\n  font-weight: bold;\n}\n\n.round-stats {\n  text-align: center;\n}\n\n.round-score-count {\n  font-size: 1.5em;\n  font-weight: bold;\n  color: #007bff;\n}\n\n.round-score-label {\n  color: #666;\n  font-size: 0.9em;\n}\n\n/* Modal Styles */\n.round-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0,0,0,0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.round-modal {\n  background-color: white;\n  padding: 30px;\n  border-radius: 12px;\n  max-width: 800px;\n  max-height: 80vh;\n  overflow: auto;\n}\n\n.round-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.round-modal-title {\n  margin: 0;\n  color: #333;\n  font-size: 1.5em;\n  font-weight: 600;\n}\n\n.round-modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  transition: color 0.3s ease;\n}\n\n.round-modal-close:hover {\n  color: #333;\n}\n\n.round-modal-info {\n  margin-bottom: var(--spacing-lg);\n  padding: var(--spacing-md);\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-primary);\n}\n\n.round-scores-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: var(--spacing-md);\n}\n\n.round-scores-table th {\n  padding: var(--spacing-sm);\n  text-align: left;\n  background-color: var(--bg-tertiary);\n  border-bottom: 1px solid var(--border-primary);\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.round-scores-table td {\n  padding: var(--spacing-sm);\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.round-scores-table tr:hover {\n  background-color: var(--bg-tertiary);\n}\n\n.score-status {\n  padding: var(--spacing-xs) var(--spacing-sm);\n  border-radius: var(--radius-sm);\n  font-size: var(--font-size-xs);\n  font-weight: bold;\n  color: white;\n}\n\n.score-status.completed {\n  background-color: var(--success);\n}\n\n.score-status.in-progress {\n  background-color: var(--warning);\n}\n\n/* Player Status Indicator */\n.player-status-indicator {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-left: 10px;\n}\n\n.player-status-indicator.active {\n  background-color: #28a745;\n}\n\n.player-status-indicator.inactive {\n  background-color: #dc3545;\n}\n\n/* Betting Tab Styles */\n.betting-grid {\n  display: grid;\n  gap: 20px;\n}\n\n.wallet-card {\n  padding: 20px;\n}\n\n.wallet-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.wallet-title {\n  margin: 0;\n  color: #333;\n}\n\n.wallet-balance {\n  font-size: 2em;\n  font-weight: bold;\n  color: #28a745;\n  margin: 10px 0 0 0;\n}\n\n.available-players-card,\n.my-players-card {\n  padding: 20px;\n}\n\n.available-players-title,\n.my-players-title {\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.available-players-grid,\n.my-players-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 15px;\n}\n\n.player-betting-card {\n  padding: 15px;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  background-color: #f8f9fa;\n}\n\n.player-betting-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.player-betting-info {\n  flex: 1;\n}\n\n.player-betting-name {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.player-betting-title {\n  margin: 0;\n  color: #333;\n}\n\n.player-betting-details {\n  color: #666;\n  font-size: 0.9em;\n  margin-bottom: 5px;\n}\n\n.player-betting-status {\n  color: #666;\n  font-size: 0.9em;\n}\n\n.player-betting-price {\n  text-align: right;\n}\n\n.price-amount {\n  font-size: 1.5em;\n  font-weight: bold;\n  color: #28a745;\n  margin-bottom: 8px;\n}\n\n.my-player-card {\n  padding: 15px;\n  border: 1px solid #28a745;\n  border-radius: 8px;\n  background-color: #e8f5e8;\n}\n\n.my-player-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.my-player-info {\n  flex: 1;\n}\n\n.my-player-name-section {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.my-player-name {\n  margin: 0;\n  color: #333;\n}\n\n.my-player-details {\n  color: #666;\n  font-size: 0.9em;\n  margin-bottom: 5px;\n}\n\n.my-player-purchase {\n  color: #28a745;\n  font-size: 0.9em;\n  font-weight: bold;\n}\n\n.text-right {\n  text-align: right;\n}\n\n/* Not Found Styles */\n.not-found-container {\n  padding: 40px;\n  text-align: center;\n}\n\n.not-found-title {\n  color: #666;\n  margin-bottom: 10px;\n}\n\n.not-found-message {\n  color: #999;\n  margin-bottom: 20px;\n}\n\n/* Loading Styles */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 400px;\n  color: #666;\n}\n\n.loading-content {\n  text-align: center;\n}\n\n/* Tournament Details main loading spinner */\n.tournament-details-loading-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\n.tournament-details-spinner {\n  animation: spin 1s linear infinite;\n  border-radius: 50%;\n  height: 48px;\n  width: 48px;\n  border-bottom: 2px solid #2563eb;\n  margin: 0 auto;\n}\n\n.loading-text {\n  margin-top: 16px;\n  color: #6b7280;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Additional Utility Classes */\n.section-margin {\n  margin-bottom: 20px;\n}\n\n.section-title {\n  color: #555;\n  margin-bottom: 10px;\n}\n\n.section-content {\n  padding-left: 20px;\n}\n\n.section-item {\n  margin-bottom: 5px;\n}\n\n.overflow-auto {\n  overflow-x: auto;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-center {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 10px;\n}\n\n/* Status Badge */\n.status-badge {\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.9em;\n  font-weight: bold;\n}\n\n/* Live Simulation Status */\n.live-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(135deg, #00ff88, #00cc6a);\n  color: #000;\n  padding: 8px 16px;\n  border-radius: 25px;\n  font-weight: bold;\n  font-size: 0.9em;\n  margin-left: 15px;\n  animation: pulse 2s infinite;\n}\n\n.live-indicator {\n  width: 8px;\n  height: 8px;\n  background: #ff4444;\n  border-radius: 50%;\n  animation: blink 1s infinite;\n}\n\n@keyframes blink {\n  0%, 50% { opacity: 1; }\n  51%, 100% { opacity: 0; }\n}\n\n@keyframes pulse {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.05); }\n  100% { transform: scale(1); }\n}\n\n.live-text {\n  font-size: 0.9em;\n}\n\n/* Notification System */\n.notification-container {\n  position: relative;\n}\n\n.notification-bell {\n  background: #2a2a2a;\n  border: 2px solid #00ff88;\n  border-radius: 50%;\n  width: 45px;\n  height: 45px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 1.2em;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.notification-bell:hover {\n  background: #00ff88;\n  transform: scale(1.1);\n}\n\n.notification-badge {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  background: #ff4444;\n  color: white;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.7em;\n  font-weight: bold;\n}\n\n.notification-dropdown {\n  position: absolute;\n  top: 50px;\n  right: 0;\n  width: 350px;\n  background: #1e1e1e;\n  border: 1px solid #333333;\n  border-radius: 1rem;\n  box-shadow: 0 8px 32px rgba(0, 255, 136, 0.2);\n  z-index: 1000;\n  animation: slideDown 0.3s ease;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.notification-header {\n  padding: 1rem;\n  border-bottom: 1px solid #333333;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.notification-header h4 {\n  margin: 0;\n  color: #ffffff;\n  font-size: 1.1em;\n}\n\n.skins-count {\n  color: #00ff88;\n  font-size: 0.9em;\n  font-weight: bold;\n}\n\n.notification-list {\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.no-notifications {\n  padding: 2rem;\n  text-align: center;\n  color: #888888;\n}\n\n.notification-item {\n  padding: 1rem;\n  border-bottom: 1px solid #333333;\n  transition: background 0.2s ease;\n  cursor: pointer;\n}\n\n.notification-item:hover {\n  background: #2a2a2a;\n}\n\n.notification-item.my-player {\n  background: rgba(0, 255, 136, 0.1);\n  border-left: 4px solid #00ff88;\n}\n\n.notification-content {\n  color: #ffffff;\n  font-size: 0.95em;\n  line-height: 1.4;\n  margin-bottom: 0.5rem;\n}\n\n.my-player-tag {\n  background: #00ff88;\n  color: #000;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 0.7em;\n  font-weight: bold;\n  margin-left: 8px;\n}\n\n.notification-time {\n  color: #888888;\n  font-size: 0.8em;\n}\n\n.notification-footer {\n  padding: 1rem;\n  border-top: 1px solid #333333;\n  text-align: center;\n}\n\n.clear-notifications {\n  background: transparent;\n  color: #00ff88;\n  border: 1px solid #00ff88;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9em;\n  transition: all 0.3s ease;\n}\n\n.clear-notifications:hover {\n  background: #00ff88;\n  color: #000;\n}\n\n/* Responsive Design for Mobile */\n@media (max-width: 768px) {\n  .header-actions {\n    gap: 10px;\n  }\n  \n  .notification-dropdown {\n    width: 300px;\n    right: -50px;\n  }\n  \n  .live-status {\n    margin-left: 8px;\n    padding: 6px 12px;\n    font-size: 0.8em;\n  }\n  \n  .notification-bell {\n    width: 40px;\n    height: 40px;\n    font-size: 1.1em;\n  }\n}\n\n@media (max-width: 480px) {\n  .tournament-title-section {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .header-actions {\n    justify-content: flex-end;\n  }\n  \n  .notification-dropdown {\n    width: 280px;\n    right: -100px;\n  }\n  \n  .live-status {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
